import { createFileRoute } from "@tanstack/react-router";
import AdminReportExplorePage from "@/admin/pages/report-explore";
import { validateReportSearch, type ReportSearch } from "@/admin/reporting/url-state";

export const Route = createFileRoute("/admin/reports/explore")({
  component: Page,
  validateSearch: (search: Record<string, unknown>): ReportSearch => validateReportSearch(search),
});

function Page() {
  const search = Route.useSearch();
  return <AdminReportExplorePage search={search} />;
}
